export const NAVIGATION_METHOD = {
  PUSH: 'push',
  NAVIGATE: 'navigate',
} as const
